import React from "react";
import styled from "styled-components";

function DetailPageForm(props) {
  return (
    <>
      <DetailPageFormWrapper
        style={{
          ...props.style,
        }}
      >
        {props.children}
      </DetailPageFormWrapper>
    </>
  );
}

export default DetailPageForm;

const DetailPageFormWrapper = styled.div.attrs((props) => {})`
  max-width: 1044px;
  display: flex;
  align-items: center;
  position: relative;
  gap: 70px;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.12);
`;
